var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 726 424",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M722,138C722,133.585 718.415,130 714,130L8,130C3.585,130 0,133.585 0,138L0,470C0,474.415 3.585,478 8,478L714,478C718.415,478 722,474.415 722,470L722,138Z",
    style: {
      fill: "rgb(46,225,118)",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,132L443,444",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.748,186.388C474.564,203.938 444,201.5 444,201.5C444,201.5 444.325,170.788 463.509,153.4C482.693,136.013 513.258,138.288 513.258,138.288C513.258,138.288 512.933,169 493.748,186.388Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.163,201.663L485.782,161.525",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.896,344.5C364.248,369.2 326.368,371.475 326.368,371.475C326.368,371.475 321.816,333.775 342.301,309.075C362.785,284.375 400.828,282.1 400.828,282.1C400.828,282.1 405.543,319.8 384.896,344.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.936,
    y: 216.775,
    width: 70.72,
    height: 52.163,
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.936,216.775L326.043,216.775",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.08,257.4L360.184,243.75L369.776,246.512L389.448,227.012",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.408,227.013L390.748,225.55L390.748,231.238",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.08,
    y: 225.55,
    width: 10.73,
    height: 5.688,
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.043,153.725L326.043,450.775",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.687,249.438C328.319,265.85 325.88,291.85 325.88,291.85C325.88,291.85 299.868,291.038 285.399,274.625C270.767,258.213 273.206,232.213 273.206,232.213C273.206,232.213 299.055,232.863 313.687,249.438Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.804,140.4C343.114,154.05 326.693,160.225 326.693,160.225C326.693,160.225 319.54,144.138 325.23,130.488C330.92,116.838 347.341,110.663 347.341,110.663C347.341,110.663 354.494,126.75 348.804,140.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.46,153.563C304.095,146.088 306.209,135.363 306.209,135.363C306.209,135.363 316.939,136.825 322.304,144.3C327.669,151.775 325.555,162.5 325.555,162.5C325.555,162.5 314.825,161.038 309.46,153.563Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.368,371.313L361.81,325.488",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.794,261.95L325.88,291.688",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.801,149.013L325.555,162.5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.862,130.488L326.531,160.225",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467,
    y: 348,
    width: 255,
    height: 55,
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.021,207.675L570.647,213.2",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.62,194.025L588.693,201.662",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.156,160.225L584.304,162.5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.656,303.712L622.184,308.912",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.184,325.325L619.42,330.525",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.92,272.675L642.344,277.388",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.089,288.438L391.488,295.1",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.445,288.437L411.81,286.162",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.512,162.337L385.96,168.187",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.598,168.025L419.776,166.238",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.5,447.688L420.264,455.487",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.046,451.587L411.81,455.487",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.684,444.438L485.457,455.487",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.555,455.488L462.209,454.35C462.209,454.35 461.233,438.263 461.396,430.463C461.558,422.663 437.985,427.213 437.985,427.213L437.66,443.95C437.497,443.95 428.23,447.363 428.555,455.488Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.822,442.65L444.65,442.65",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.764,452.562L624.948,424.937C624.948,424.937 611.617,416.162 605.276,411.287C599.098,406.575 588.693,428.187 588.693,428.187L601.862,438.425C601.862,438.425 599.098,447.85 605.764,452.562Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.049,437.45L605.113,431.925",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.997,279.337C512.12,274.462 502.202,273.65 497.488,279.337C461.721,321.912 439.936,378.462 436.359,433.875C444.813,436.15 463.672,438.425 463.672,437.937C466.11,388.7 485.132,336.537 516.997,298.837C521.874,293.15 522.687,285.025 516.997,279.337Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.969,434.037C597.31,427.375 603.813,419.575 609.991,412.75C568.046,373.75 543.822,324.35 542.196,266.987C541.709,249.275 514.071,249.112 514.558,266.987C516.509,331.5 543.497,390.162 590.969,434.037Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.485,297.05L511.469,295.1",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.037,303.387C569.184,304.037 563.169,304.85 557.316,305.662C557.316,305.825 557.316,305.987 557.154,306.15C556.828,308.75 557.479,311.187 558.617,313.462C559.267,314.6 560.242,315.087 561.218,315.087C565.12,313.625 569.184,313.137 573.249,313.137C574.712,310.05 575.199,306.8 575.037,303.387Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.847,250.25C487.245,260.325 480.255,268.612 470.5,272.512C459.282,277.062 447.252,272.35 435.871,275.112C437.985,281.612 440.098,288.112 442.212,294.612C450.341,294.937 456.681,295.425 463.834,294.775C471.15,294.125 478.304,291.85 484.644,288.275C497,281.287 503.828,268.612 507.405,254.962C510.656,242.125 493.098,237.412 489.847,250.25Z",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.521,273.163L497.65,279.337C483.181,244.725 491.147,241.475 500.739,238.063C502.365,237.413 503.991,236.925 505.617,236.113C507.405,235.3 509.031,234.65 510.494,234.163C524.801,229.938 530.003,242.125 532.117,248.625C534.23,255.775 542.521,273.163 542.521,273.163Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.963,305.175C572.761,274.625 553.414,248.137 525.126,235.137C512.77,229.45 505.454,247.812 517.81,253.5C539.595,263.412 553.414,283.887 557.153,307.775C564.144,307.125 570.972,305.987 577.963,305.175Z",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.709,275.113C431.156,275.6 421.89,279.5 420.426,283.4C418.801,287.3 423.028,284.213 425.304,283.4C425.304,283.4 418.638,286 420.101,288.763C421.564,291.525 424.816,287.625 426.767,287.463C426.767,287.463 421.077,290.225 422.703,292.338C424.328,294.45 428.393,289.25 430.831,291.038C433.27,292.825 427.905,296.075 429.693,297.05C431.482,298.025 433.595,295.1 442.374,294.775",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.709,275.113C431.156,275.6 421.89,279.5 420.426,283.4C418.801,287.3 423.028,284.213 425.304,283.4C425.304,283.4 418.638,286 420.101,288.763C421.564,291.525 424.816,287.625 426.767,287.463C426.767,287.463 421.077,290.225 422.703,292.338C424.328,294.45 428.393,289.25 430.831,291.038C433.27,292.825 427.905,296.075 429.693,297.05C431.482,298.025 433.595,295.1 442.374,294.775",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.153,307.938C556.341,314.6 558.454,318.988 562.356,320.288L557.153,307.938Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.153,307.938C556.341,314.6 558.454,318.988 562.356,320.288",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.592,312.812C561.055,316.225 565.12,325.162 568.534,325.325C571.948,325.487 567.558,317.687 567.558,317.687C567.558,317.687 570.972,325.325 574.549,325C576.337,324.837 572.598,316.55 572.598,316.55C572.598,316.55 575.525,324.187 577.801,323.862C580.239,323.537 576.825,316.55 577.475,314.112C577.963,312.487 578.939,309.4 578.126,305.337",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.592,312.812C561.055,316.225 565.12,325.162 568.534,325.325C571.948,325.487 567.558,317.687 567.558,317.687C567.558,317.687 570.972,325.325 574.549,325C576.337,324.837 572.598,316.55 572.598,316.55C572.598,316.55 575.525,324.187 577.801,323.862C580.239,323.537 576.825,316.55 577.475,314.112C577.963,312.487 578.939,309.4 578.126,305.337",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.132,219.212C479.279,228.312 480.905,221.487 467.574,225.55C454.08,229.612 457.982,233.675 453.755,236.925C449.528,240.175 445.138,245.212 463.347,243.425C481.555,241.637 486.595,238.55 489.196,235.95C491.798,233.35 498.951,230.425 500.739,223.437C502.528,216.287 485.132,219.212 485.132,219.212Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.356,234.487L504.966,228.962L500.577,223.437C501.552,221.65 501.715,219.212 500.902,215.8C498.951,208.65 489.684,209.95 487.083,214.5C484.482,219.05 484.482,222.462 484.482,222.462L486.433,223.112C486.433,223.112 487.571,228.312 492.611,227.825L497.813,234.325L500.577,237.9C500.414,237.9 500.414,237.9 500.252,238.062L501.227,250.087L509.518,235.137L510.006,234.162C510.006,234.162 509.681,234.325 509.356,234.487Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.049,210.275C492.123,210.437 489.359,211.575 487.245,214.337C489.359,216.45 493.911,217.587 495.862,217.587C497.65,217.587 497.813,220.025 496.512,220.837C495.374,221.487 498.788,223.6 499.601,223.6L500.577,223.6C501.715,221.812 501.877,219.212 501.064,215.8C500.902,215.15 500.739,214.5 500.577,213.687C498.788,212.387 496.837,211.25 495.049,210.275Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.377,420.387C502.528,395.362 503.34,352.625 503.34,352.625C503.34,352.625 545.936,350.675 571.785,375.862C597.635,401.05 596.822,443.625 596.822,443.625C596.822,443.625 554.227,445.412 528.377,420.387Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.239,338L596.822,338",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.416,
    y: 338.063,
    width: 49.911,
    height: 61.912,
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.436,367.575C572.436,377 564.795,384.8 555.203,384.8C545.773,384.8 537.969,377.162 537.969,367.575C537.969,357.987 545.611,350.35 555.203,350.35C564.795,350.35 572.436,356.687 572.436,367.575Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.558,354.9L555.365,367.575L572.436,367.575",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.733,358.637L555.365,367.575",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.982,387.887L571.298,387.887",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.982,390.975L571.298,390.975",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.822,455.487L596.822,243.75",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.058,390.975C627.712,408.687 596.985,406.25 596.985,406.25C596.985,406.25 597.31,375.375 616.657,357.662C636.003,339.95 666.73,342.387 666.73,342.387C666.73,342.387 666.242,373.262 647.058,390.975Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.209,243.75C614.055,257.237 596.66,261.95 596.66,261.95C596.66,261.95 590.807,244.887 597.96,231.4C605.114,217.912 622.509,213.2 622.509,213.2C622.509,213.2 628.199,230.262 621.209,243.75Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.822,406.25L641.693,365.137",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.982,408.688L596.822,443.625",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.715,235.625L596.66,261.95",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.62,338L591.62,343.85",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.215,362.887C140.003,440.822 20.361,448 20.361,448C20.361,448 5.984,329.047 70.683,251.113C135.381,173.178 255.536,166 255.536,166C255.536,166 270.427,284.953 205.215,362.887Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.893,
    y: 299,
    width: 70.72,
    height: 52.163,
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.893,299L102,299",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.402,420.378C138.759,443.867 102.721,446.031 102.721,446.031C102.721,446.031 98.391,410.178 117.879,386.689C137.367,363.199 173.559,361.036 173.559,361.036C173.559,361.036 178.044,396.888 158.402,420.378Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.279,238.852L102.279,452.539",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.657,329.974C104.577,345.582 102.257,370.308 102.257,370.308C102.257,370.308 77.51,369.535 63.745,353.927C49.825,338.319 52.145,313.593 52.145,313.593C52.145,313.593 76.737,314.211 90.657,329.974Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.066,226.28C118.652,239.261 103.031,245.134 103.031,245.134C103.031,245.134 96.225,229.835 101.639,216.853C107.052,203.872 122.674,198 122.674,198C122.674,198 129.479,213.299 124.066,226.28Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.636,238.798C81.532,231.689 83.543,221.49 83.543,221.49C83.543,221.49 93.751,222.88 98.855,229.989C103.959,237.098 101.948,247.297 101.948,247.297C101.948,247.297 91.74,245.906 86.636,238.798Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.721,445.876L136.439,402.297",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.295,341.874L102.257,370.154",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.668,234.471L101.948,247.297",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.559,216.854L102.876,245.134",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92,83.224C8.363,83.224 6.955,82.957 5.696,82.424C4.459,81.891 3.477,81.123 2.752,80.12C2.027,79.117 1.653,77.933 1.632,76.568L6.432,76.568C6.496,77.485 6.816,78.211 7.392,78.744C7.989,79.277 8.8,79.544 9.824,79.544C10.869,79.544 11.691,79.299 12.288,78.808C12.885,78.296 13.184,77.635 13.184,76.824C13.184,76.163 12.981,75.619 12.576,75.192C12.171,74.765 11.659,74.435 11.04,74.2C10.443,73.944 9.611,73.667 8.544,73.368C7.093,72.941 5.909,72.525 4.992,72.12C4.096,71.693 3.317,71.064 2.656,70.232C2.016,69.379 1.696,68.248 1.696,66.84C1.696,65.517 2.027,64.365 2.688,63.384C3.349,62.403 4.277,61.656 5.472,61.144C6.667,60.611 8.032,60.344 9.568,60.344C11.872,60.344 13.739,60.909 15.168,62.04C16.619,63.149 17.419,64.707 17.568,66.712L12.64,66.712C12.597,65.944 12.267,65.315 11.648,64.824C11.051,64.312 10.251,64.056 9.248,64.056C8.373,64.056 7.669,64.28 7.136,64.728C6.624,65.176 6.368,65.827 6.368,66.68C6.368,67.277 6.56,67.779 6.944,68.184C7.349,68.568 7.84,68.888 8.416,69.144C9.013,69.379 9.845,69.656 10.912,69.976C12.363,70.403 13.547,70.829 14.464,71.256C15.381,71.683 16.171,72.323 16.832,73.176C17.493,74.029 17.824,75.149 17.824,76.536C17.824,77.731 17.515,78.84 16.896,79.864C16.277,80.888 15.371,81.709 14.176,82.328C12.981,82.925 11.563,83.224 9.92,83.224ZM26.924,68.952L26.924,77.528C26.924,78.125 27.063,78.563 27.34,78.84C27.639,79.096 28.129,79.224 28.812,79.224L30.892,79.224L30.892,83L28.076,83C24.3,83 22.412,81.165 22.412,77.496L22.412,68.952L20.3,68.952L20.3,65.272L22.412,65.272L22.412,60.888L26.924,60.888L26.924,65.272L30.892,65.272L30.892,68.952L26.924,68.952ZM50.85,65.272L50.85,83L46.338,83L46.338,80.76C45.762,81.528 45.005,82.136 44.066,82.584C43.149,83.011 42.146,83.224 41.058,83.224C39.672,83.224 38.445,82.936 37.378,82.36C36.312,81.763 35.469,80.899 34.85,79.768C34.253,78.616 33.954,77.251 33.954,75.672L33.954,65.272L38.434,65.272L38.434,75.032C38.434,76.44 38.786,77.528 39.49,78.296C40.194,79.043 41.154,79.416 42.37,79.416C43.608,79.416 44.578,79.043 45.282,78.296C45.986,77.528 46.338,76.44 46.338,75.032L46.338,65.272L50.85,65.272ZM54.118,74.072C54.118,72.28 54.471,70.691 55.175,69.304C55.9,67.917 56.881,66.851 58.118,66.104C59.356,65.357 60.732,64.984 62.246,64.984C63.399,64.984 64.497,65.24 65.543,65.752C66.588,66.243 67.42,66.904 68.039,67.736L68.039,59.32L72.583,59.32L72.583,83L68.039,83L68.039,80.376C67.484,81.251 66.705,81.955 65.703,82.488C64.7,83.021 63.537,83.288 62.215,83.288C60.721,83.288 59.356,82.904 58.118,82.136C56.881,81.368 55.9,80.291 55.175,78.904C54.471,77.496 54.118,75.885 54.118,74.072ZM68.071,74.136C68.071,73.048 67.857,72.12 67.431,71.352C67.004,70.563 66.428,69.965 65.703,69.56C64.977,69.133 64.198,68.92 63.367,68.92C62.535,68.92 61.767,69.123 61.063,69.528C60.359,69.933 59.783,70.531 59.335,71.32C58.908,72.088 58.695,73.005 58.695,74.072C58.695,75.139 58.908,76.077 59.335,76.888C59.783,77.677 60.359,78.285 61.063,78.712C61.788,79.139 62.556,79.352 63.367,79.352C64.198,79.352 64.977,79.149 65.703,78.744C66.428,78.317 67.004,77.72 67.431,76.952C67.857,76.163 68.071,75.224 68.071,74.136ZM93.438,73.752C93.438,74.392 93.395,74.968 93.31,75.48L80.35,75.48C80.457,76.76 80.905,77.763 81.694,78.488C82.483,79.213 83.454,79.576 84.606,79.576C86.27,79.576 87.454,78.861 88.158,77.432L92.99,77.432C92.478,79.139 91.497,80.547 90.046,81.656C88.595,82.744 86.814,83.288 84.702,83.288C82.995,83.288 81.459,82.915 80.094,82.168C78.75,81.4 77.694,80.323 76.926,78.936C76.179,77.549 75.806,75.949 75.806,74.136C75.806,72.301 76.179,70.691 76.926,69.304C77.673,67.917 78.718,66.851 80.062,66.104C81.406,65.357 82.953,64.984 84.702,64.984C86.387,64.984 87.891,65.347 89.214,66.072C90.558,66.797 91.593,67.832 92.318,69.176C93.065,70.499 93.438,72.024 93.438,73.752ZM88.798,72.472C88.777,71.32 88.361,70.403 87.55,69.72C86.739,69.016 85.747,68.664 84.574,68.664C83.465,68.664 82.526,69.005 81.758,69.688C81.011,70.349 80.553,71.277 80.382,72.472L88.798,72.472ZM106.532,65.016C108.644,65.016 110.351,65.688 111.652,67.032C112.953,68.355 113.604,70.211 113.604,72.6L113.604,83L109.124,83L109.124,73.208C109.124,71.8 108.772,70.723 108.068,69.976C107.364,69.208 106.404,68.824 105.188,68.824C103.951,68.824 102.969,69.208 102.244,69.976C101.54,70.723 101.188,71.8 101.188,73.208L101.188,83L96.708,83L96.708,65.272L101.188,65.272L101.188,67.48C101.785,66.712 102.543,66.115 103.46,65.688C104.399,65.24 105.423,65.016 106.532,65.016ZM123.08,68.952L123.08,77.528C123.08,78.125 123.219,78.563 123.496,78.84C123.795,79.096 124.286,79.224 124.968,79.224L127.048,79.224L127.048,83L124.232,83C120.456,83 118.568,81.165 118.568,77.496L118.568,68.952L116.456,68.952L116.456,65.272L118.568,65.272L118.568,60.888L123.08,60.888L123.08,65.272L127.048,65.272L127.048,68.952L123.08,68.952ZM136.808,71.8C136.808,69.603 137.298,67.64 138.28,65.912C139.282,64.163 140.637,62.808 142.344,61.848C144.072,60.867 146.002,60.376 148.136,60.376C150.632,60.376 152.818,61.016 154.696,62.296C156.573,63.576 157.885,65.347 158.632,67.608L153.48,67.608C152.968,66.541 152.242,65.741 151.304,65.208C150.386,64.675 149.32,64.408 148.104,64.408C146.802,64.408 145.64,64.717 144.616,65.336C143.613,65.933 142.824,66.787 142.248,67.896C141.693,69.005 141.416,70.307 141.416,71.8C141.416,73.272 141.693,74.573 142.248,75.704C142.824,76.813 143.613,77.677 144.616,78.296C145.64,78.893 146.802,79.192 148.104,79.192C149.32,79.192 150.386,78.925 151.304,78.392C152.242,77.837 152.968,77.027 153.48,75.96L158.632,75.96C157.885,78.243 156.573,80.024 154.696,81.304C152.84,82.563 150.653,83.192 148.136,83.192C146.002,83.192 144.072,82.712 142.344,81.752C140.637,80.771 139.282,79.416 138.28,77.688C137.298,75.96 136.808,73.997 136.808,71.8ZM170.33,83.288C168.623,83.288 167.087,82.915 165.722,82.168C164.357,81.4 163.279,80.323 162.49,78.936C161.722,77.549 161.338,75.949 161.338,74.136C161.338,72.323 161.733,70.723 162.522,69.336C163.333,67.949 164.431,66.883 165.818,66.136C167.205,65.368 168.751,64.984 170.458,64.984C172.165,64.984 173.711,65.368 175.098,66.136C176.485,66.883 177.573,67.949 178.362,69.336C179.173,70.723 179.578,72.323 179.578,74.136C179.578,75.949 179.162,77.549 178.33,78.936C177.519,80.323 176.41,81.4 175.002,82.168C173.615,82.915 172.058,83.288 170.33,83.288ZM170.33,79.384C171.141,79.384 171.898,79.192 172.602,78.808C173.327,78.403 173.903,77.805 174.33,77.016C174.757,76.227 174.97,75.267 174.97,74.136C174.97,72.451 174.522,71.16 173.626,70.264C172.751,69.347 171.674,68.888 170.394,68.888C169.114,68.888 168.037,69.347 167.162,70.264C166.309,71.16 165.882,72.451 165.882,74.136C165.882,75.821 166.298,77.123 167.13,78.04C167.983,78.936 169.05,79.384 170.33,79.384ZM185.136,63.16C184.347,63.16 183.686,62.915 183.152,62.424C182.64,61.912 182.384,61.283 182.384,60.536C182.384,59.789 182.64,59.171 183.152,58.68C183.686,58.168 184.347,57.912 185.136,57.912C185.926,57.912 186.576,58.168 187.088,58.68C187.622,59.171 187.888,59.789 187.888,60.536C187.888,61.283 187.622,61.912 187.088,62.424C186.576,62.915 185.926,63.16 185.136,63.16ZM187.344,65.272L187.344,83L182.864,83L182.864,65.272L187.344,65.272ZM201.595,65.016C203.707,65.016 205.413,65.688 206.715,67.032C208.016,68.355 208.667,70.211 208.667,72.6L208.667,83L204.187,83L204.187,73.208C204.187,71.8 203.835,70.723 203.131,69.976C202.427,69.208 201.467,68.824 200.251,68.824C199.013,68.824 198.032,69.208 197.307,69.976C196.603,70.723 196.251,71.8 196.251,73.208L196.251,83L191.771,83L191.771,65.272L196.251,65.272L196.251,67.48C196.848,66.712 197.605,66.115 198.523,65.688C199.461,65.24 200.485,65.016 201.595,65.016ZM250.408,60.664L244.168,83L238.888,83L234.696,67.096L230.312,83L225.064,83.032L219.048,60.664L223.848,60.664L227.784,78.008L232.328,60.664L237.32,60.664L241.608,77.912L245.576,60.664L250.408,60.664ZM252.181,74.072C252.181,72.28 252.533,70.691 253.237,69.304C253.962,67.917 254.933,66.851 256.149,66.104C257.386,65.357 258.762,64.984 260.277,64.984C261.6,64.984 262.752,65.251 263.733,65.784C264.736,66.317 265.536,66.989 266.133,67.8L266.133,65.272L270.645,65.272L270.645,83L266.133,83L266.133,80.408C265.557,81.24 264.757,81.933 263.733,82.488C262.73,83.021 261.568,83.288 260.245,83.288C258.752,83.288 257.386,82.904 256.149,82.136C254.933,81.368 253.962,80.291 253.237,78.904C252.533,77.496 252.181,75.885 252.181,74.072ZM266.133,74.136C266.133,73.048 265.92,72.12 265.493,71.352C265.066,70.563 264.49,69.965 263.765,69.56C263.04,69.133 262.261,68.92 261.429,68.92C260.597,68.92 259.829,69.123 259.125,69.528C258.421,69.933 257.845,70.531 257.397,71.32C256.97,72.088 256.757,73.005 256.757,74.072C256.757,75.139 256.97,76.077 257.397,76.888C257.845,77.677 258.421,78.285 259.125,78.712C259.85,79.139 260.618,79.352 261.429,79.352C262.261,79.352 263.04,79.149 263.765,78.744C264.49,78.317 265.066,77.72 265.493,76.952C265.92,76.163 266.133,75.224 266.133,74.136ZM279.501,59.32L279.501,83L275.021,83L275.021,59.32L279.501,59.32ZM288.407,59.32L288.407,83L283.927,83L283.927,59.32L288.407,59.32ZM309.313,73.752C309.313,74.392 309.27,74.968 309.185,75.48L296.225,75.48C296.332,76.76 296.78,77.763 297.569,78.488C298.358,79.213 299.329,79.576 300.481,79.576C302.145,79.576 303.329,78.861 304.033,77.432L308.865,77.432C308.353,79.139 307.372,80.547 305.921,81.656C304.47,82.744 302.689,83.288 300.577,83.288C298.87,83.288 297.334,82.915 295.969,82.168C294.625,81.4 293.569,80.323 292.801,78.936C292.054,77.549 291.681,75.949 291.681,74.136C291.681,72.301 292.054,70.691 292.801,69.304C293.548,67.917 294.593,66.851 295.937,66.104C297.281,65.357 298.828,64.984 300.577,64.984C302.262,64.984 303.766,65.347 305.089,66.072C306.433,66.797 307.468,67.832 308.193,69.176C308.94,70.499 309.313,72.024 309.313,73.752ZM304.673,72.472C304.652,71.32 304.236,70.403 303.425,69.72C302.614,69.016 301.622,68.664 300.449,68.664C299.34,68.664 298.401,69.005 297.633,69.688C296.886,70.349 296.428,71.277 296.257,72.472L304.673,72.472ZM317.799,68.952L317.799,77.528C317.799,78.125 317.938,78.563 318.215,78.84C318.514,79.096 319.004,79.224 319.687,79.224L321.767,79.224L321.767,83L318.951,83C315.175,83 313.287,81.165 313.287,77.496L313.287,68.952L311.175,68.952L311.175,65.272L313.287,65.272L313.287,60.888L317.799,60.888L317.799,65.272L321.767,65.272L321.767,68.952L317.799,68.952Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.5,44.5,-44.5,-5.5,595,375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0,150,109)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0,150,109)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-107.655,158.555,-158.555,-107.655,138.467,304.436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0,150,109)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0,150,109)",
      stopOpacity: 0
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide4);
export default __webpack_public_path__ + "static/media/slide4.e02b217663a2cf6e76944453dad968ce.svg";
export { ForwardRef as ReactComponent };